import { gql, useMutation } from '@apollo/client'
import { CreateCartMutation, CreateCartMutationVariables } from 'types/graphql'
import { cartFieldsFragment } from './cartFieldsFragment'

const mutation = gql`
  ${cartFieldsFragment}

  mutation CreateCart($productVariants: [CartSkuUpdateInput!]!) {
    createCart(productVariants: $productVariants) {
      ...CartFields
    }
  }
`

export const useCreateCart = () => {
  return useMutation<CreateCartMutation, CreateCartMutationVariables>(mutation, { fetchPolicy: 'no-cache' })
}
